module.exports = __webpack_public_path__ + "static/media/34DSS5.3a7ff74d.jpg";